function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.3333 6.57019L14.2121 10.6308V24.3636L22.3333 28.4242V6.57019ZM26.3939 0L11.7026 7.34566H4.0606C1.81799 7.34566 0 9.16366 0 11.4063V23.5881C0 25.8307 1.81799 27.6487 4.0606 27.6487H11.7024L26.3939 34.9944V0ZM4.06062 11.4063H10.1515V23.5881H4.06062V11.4063ZM36.5455 17.4972C36.5455 12.6028 34.6469 8.18295 31.6215 5.19397L28.4187 7.75618C30.8752 9.96825 32.4849 13.4887 32.4849 17.4972C32.4849 21.5057 30.8752 25.0261 28.4187 27.2382L31.6215 29.8004C34.6469 26.8114 36.5455 22.3916 36.5455 17.4972Z",
  fill: "white"
});

var SvgSoundMed = function SvgSoundMed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    viewBox: "0 0 45 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoundMed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound_med.3ab8b488.svg";
export { ForwardRef as ReactComponent };